import React from 'react'

import {
  Checkbox,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText
} from '@material-ui/core'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import ArrowRight from '@material-ui/icons/ChevronRight'

import { useDesktop } from '~/hooks/responsive'

import { ListItemBoxProps } from './types'

const useStyles = makeStyles(
  () =>
    createStyles({
      icon: {
        minWidth: 26
      }
    }),
  { name: 'ListBoxItem' }
)

const ListBoxItem = ({
  selected,
  option,
  active,
  value,
  onChange,
  hideCheckbox,
  rightAdornment,
  primary,
  ...props
}: ListItemBoxProps) => {
  const classes = useStyles()
  const isDesktop = useDesktop()

  const isSelected = selected || active
  const handleClick = () => {
    if (selected) {
      if (Array.isArray(value)) {
        onChange(value.filter((v) => v.value === option.value))
      } else {
        onChange(null)
      }
    }
  }

  return (
    <ListItem
      component="div"
      button
      dense
      selected={isSelected}
      key={option.value}
      onClick={handleClick}
      {...props}
    >
      {!hideCheckbox && (
        <ListItemIcon className={classes.icon}>
          <Checkbox
            edge="start"
            checked={selected}
            size="small"
            tabIndex={-1}
            disableRipple
            style={{ padding: '0 9px' }}
            onClick={(e) => {
              e.preventDefault()
            }}
            inputProps={{ 'aria-labelledby': option.value }}
          />
        </ListItemIcon>
      )}

      <ListItemText
        id={option.value}
        primary={primary || option.label}
        primaryTypographyProps={{
          style: { marginBottom: 0 },
          noWrap: true
        }}
      />

      {rightAdornment && rightAdornment}
      {!!option.children?.length && isDesktop && (
        <ListItemSecondaryAction style={{ cursor: 'pointer' }}>
          <ArrowRight
            fontSize="small"
            color="inherit"
            style={{ display: 'flex' }}
          />
        </ListItemSecondaryAction>
      )}
    </ListItem>
  )
}

export default ListBoxItem
